import React from 'react';
import { FaEdit } from 'react-icons/fa';
import  { ButtonGroup, EditButton} from './StyledComponents.jsx';

export const BotonEditar = ({ Editar, row }) => {
  return (
    <ButtonGroup>
      <EditButton
        type="button"
        onClick={() => Editar(row)}
        data-tooltip-id="tooltiparriba"
        data-tooltip-content="Editar"
      >
        <FaEdit />
      </EditButton>
    </ButtonGroup>
  );
};
